function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaitingPicture3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-line-drawing--picture3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "250px",
    height: "180px",
    viewBox: "0 0 250 180",
    style: {
      overflow: "visible",
      enableBackground: "new 0 0 250 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Outline",
    className: "svg-line-drawing__line",
    d: "M4,179c-1.7,0-3-1.4-3-3V4c0-1.7,1.3-3,3-3h242c1.6,0,3,1.3,3,3v172c0,1.6-1.4,3-3,3H4z",
    style: {
      strokeDasharray: 846.8409423828125,
      strokeDashoffset: 846.8409423828125
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Horizon_2",
    className: "svg-line-drawing__line",
    x1: 4.4,
    y1: 86.8,
    x2: 245.2,
    y2: 86.8,
    style: {
      strokeDasharray: 240.8000030517578,
      strokeDashoffset: 240.8000030517578
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Sun",
    className: "svg-line-drawing__line",
    d: "M189.9,86.8c0-16-13-29-29-29s-29,13-29,29",
    style: {
      strokeDasharray: 91.10499572753906,
      strokeDashoffset: 91.10499572753906
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Wave_3",
    className: "svg-line-drawing__line",
    d: "M12.9,165.1c0,0,163.5,13.9,230.2-49.8",
    style: {
      strokeDasharray: 241.1487579345703,
      strokeDashoffset: 241.1487579345703
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Wave_2",
    className: "svg-line-drawing__line",
    d: "M35.9,148.4c0,0,112.1,18,178.4-30.6",
    style: {
      strokeDasharray: 185.06588745117188,
      strokeDashoffset: 185.06588745117188
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cloud_2",
    className: "svg-line-drawing__line",
    d: "M17.9,46.3h75.7c0,0-3.7-12.1-26.5-8.2c-9-6.6-11.7-6.8-19-6.4c-15.7,1-14.9,6.6-14.9,6.6S13,38.6,17.9,46.3z",
    style: {
      strokeDasharray: 164.3153533935547,
      strokeDashoffset: 164.3153533935547
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "White",
    className: "svg-line-drawing__white",
    d: "M67.8,53.5c0,0-0.7,2.4-1,7.5c0-1.4,0.1-2.7,0.2-4.1c0,0-24.5,41.1-7,55.4c2.2-5.2,11.7-7.3,11.7-7.3s-0.7-2.8-1.5-7.3c0.6,2.8,1.2,5.7,2,8.7c5.1,0.4,14.4-3.8,14.4-3.8S75.4,97.9,67.8,53.5z",
    style: {
      strokeDasharray: 170.6197967529297,
      strokeDashoffset: 170.6197967529297
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Sail_1",
    className: "svg-line-drawing__line",
    d: "M66.9,56.9c0,0-24.5,41.1-7,55.4c2.2-5.2,11.7-7.3,11.7-7.3S65.6,80.3,66.9,56.9z",
    style: {
      strokeDasharray: 122.48445129394531,
      strokeDashoffset: 122.48445129394531
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Sail_2",
    className: "svg-line-drawing__line",
    d: "M67.8,53.5c0,0-4.8,16.8,4.3,52.9c5.1,0.4,14.4-3.8,14.4-3.8S75.4,97.9,67.8,53.5z",
    style: {
      strokeDasharray: 121.97041320800781,
      strokeDashoffset: 121.97041320800781
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Boat_1",
    className: "svg-line-drawing__line",
    d: "M62.8,114c0,0,3.4,6,14.8,6.4c11.3,0.5,15.6-2.5,15.6-2.5s2.6-2.1,1.8-6.3c-1.7,0.3-3.6,0.5-5.6,0.6c-0.7,0.1-1.1-3.5-1.7-3.4c-2.5,0.2-5.1,0.5-7.4,0.6c-5.4,0.1-9.9,3.3-9.9,3.3L62.8,114z",
    style: {
      strokeDasharray: 74.82988739013672,
      strokeDashoffset: 74.82988739013672
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Boat_2",
    className: "svg-line-drawing__line",
    d: "M90.8,119c-7.3,0.9-6-4.9-6-4.9l4.6-1.8",
    style: {
      strokeDasharray: 14.359903335571289,
      strokeDashoffset: 14.359903335571289
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Boat_3",
    className: "svg-line-drawing__line",
    x1: 84.8,
    y1: 114.1,
    x2: 62.8,
    y2: 114,
    style: {
      strokeDasharray: 22.00023078918457,
      strokeDashoffset: 22.00023078918457
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingPicture3);
export default __webpack_public_path__ + "static/media/WaitingPicture3.2ef3d634efb06e59a3da392ab42a0938.svg";
export { ForwardRef as ReactComponent };